import { useState, useEffect } from 'react'
import api, { ILocationHealthCheck } from '@api'
import { useShouldReload } from '@hooks/reloadContext'

export interface ILocationHealthCheckHook {
  healthChecks: ILocationHealthCheck[]
  isLoading: boolean
}

export function useLocationHealthChecks(): ILocationHealthCheckHook {
  const [healthChecks, sethealthChecks] = useState<ILocationHealthCheck[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const shouldReload = useShouldReload()

  useEffect(() => {
    api.company.locationHealthChecks.fetch().then((locationHealthChecks) => {
      sethealthChecks(locationHealthChecks)
      setIsLoading(false)
    })
  }, [shouldReload.locationHealthChecks])

  return { healthChecks, isLoading }
}
